import { invokeApi } from "../invokeApi";

export const _Detail_Transaction = async (transactionId) => {
  const requestObj = {
    path: `/api/transaction/detail_transaction/${transactionId}?user_id=${"balance"}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _Customer_Detail_With_Subscription_Transaction_List = async (
  data,
  page,
  limit
) => {
  const requestObj = {
    path: `/api/transaction/customer_detail_with_subscription_transaction_list?page=${page}&limit=${limit}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _List_Subscription_Transactions_For_Admin = async (
  data,
  page,
  limit
) => {
  const requestObj = {
    path: `/api/transaction/list_subscription_transactions_for_admin?page=${page}&limit=${limit}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _List_Transaction_For_Admin = async (data, page, limit) => {
  const requestObj = {
    path: `/api/transaction/list_transaction_for_admin?page=${page}&limit=${limit}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _List_Transaction_History = async (transactionId) => {
  const requestObj = {
    path: `/api/transaction/list_transaction_history/${transactionId}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _Update_Status_Transaction = async (transactionId, data) => {
  const requestObj = {
    path: `/api/transaction/update_status_transaction/${transactionId}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _List_Transaction_Detail = async (id) => {
  const requestObj = {
    path: `/api/transaction/detail_transaction/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
